(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/customer-service/assets/javascripts/router.js') >= 0) return;  svs.modules.push('/modules/customer-service/assets/javascripts/router.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.customer_service.Router = Backbone.Router.extend({
    mainView: svs.customer_service.app.getRegion(),

    routes: svs.core.data.routes,

    routeStart: function() {
      this.mainView.show(new svs.customer_service.views.HelpStart({ tab: '' }));
    },

    routeFAQ: function() {
      this.mainView.show(new svs.customer_service.views.HelpStart({ tab: 'faq' }));
    },

    routeTerms: function() {
      this.mainView.show(new svs.customer_service.views.HelpStart({ tab: 'blanketter-regler-och-villkor' }));
    },

    routeContact: function() {
      this.mainView.show(new svs.customer_service.views.HelpStart({ tab: 'kontakt' }));
    }
  });
})(Backbone, _, svs);

 })(window);